module.exports = __webpack_public_path__ + "img/swac.d6766c8e.png";